import { spire360ApiClient } from "./Spire360ApiClient";
import { ClinicalStats } from "./ClinicalStatsTypes";

// Clinical stats endpoint lives on patients-experience-api's clinical-stats
// module (see clinical-stats/clinical-stats.controller.ts) - a lightweight,
// non-AI endpoint that fetches directly from source data (conditions, acute
// care events, assessment submissions/answers) and computes the tiles live.
// No Bedrock call, no ai-summary-requests row, no generate/regenerate flow -
// unlike ClinicianAiSummaryApiHelper.ts, which this intentionally does not
// depend on. Same base-path/gateway convention as the rest of this
// codebase's patients-experience-api calls (see PatientApiHelper.ts).

const GET_CLINICAL_STATS_TIMEOUT_MS = 10000;

function getBasePath(): string {
  const isGatewayEnabled = process.env.REACT_APP_CONFIG_GATEWAY === "true";
  return isGatewayEnabled
    ? `${process.env.REACT_APP_PATIENTS_API_URL_GATEWAY}`
    : `${process.env.REACT_APP_PATIENTS_API_URL}`;
}

export interface ClinicalStatsApi {
  getClinicalStats(patientId: string): Promise<ClinicalStats>;
}

export function createClinicalStatsApi(): ClinicalStatsApi {
  return {
    getClinicalStats: async (patientId: string) => {
      const response = await spire360ApiClient.get(
        `${getBasePath()}/patients/${patientId}/clinical-stats`,
        { timeout: GET_CLINICAL_STATS_TIMEOUT_MS }
      );
      return response.data;
    },
  };
}
